/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { getRequest } from '../Auth/api';
import './../components/blogsection.css';
import './../style/common.css';

const BlogSection = () => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const data = await getRequest('blogs');

        // Only get active blogs, reverse and take top 3
        const activeBlogs = data?.data
          .filter((item) => item.is_active)
          .reverse()
          .slice(0, 3);

        setBlogs(activeBlogs);
      } catch (error) {
        console.error('Error fetching blogs:', error);
      }
    };

    fetchBlogs();
  }, []);

  return (
    <section className="latest-news-section">
      <div className="news-header">
        <div>
          <h2>LATEST NEWS</h2>
        </div>
        <a href="/informative-blog" className="explore-btn">Explore All</a>
      </div>

      <div className="news-cards-wrapper">
        {blogs.map((item, index) => (
          <div className="news-card" key={item.id}>
            <a href={`/informative-blog/${item.slug}`}>
              <div className='blog-image'>
                <img
                  src={item.featured_image}
                  alt={item.title}
                  loading="lazy"
                />
              </div>
              <div className="news-meta">
                <span>{new Date(item.created_at).toLocaleDateString()}</span>
                <span>{item.category}</span>
              </div>
              <h3 className="news-title">{item.title}</h3>
              <p className="read-more">Read More →</p>
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};

export default BlogSection;
